<template>
    <div class="indexList">
        <div class="haveContent" id="haveContent" v-if="listAllData">
            <mescroll-vue ref="mescroll" :up="mescrollUp" @init="mescrollInit">
                <!-- 新闻列表 -->
                <NewsList :listcontent="newsDataList" :dateBlock="dateBlock"></NewsList>
            </mescroll-vue>
        </div>
        <loading :iscomplete="listAllData?false:true" ></loading>
    </div>
</template>
 
<script>
import NewsList from  './NewsList' //新闻列表
import loading from './loading.vue' //加载动画
import MescrollVue from 'mescroll.js/mescroll.vue' //上拉加载，下拉刷新

export default {
    props: {
		dataLink: {  //是否显示
			type: String,
			default:()=>"", //必须是一个函数
			required: true,   
        },
        dateBlock:{
            type: Boolean,
            default:()=>true, //必须是一个函数
			required: false,  //不是必填项
        }
    },
    // props:["dataLink"],
    components:{
        NewsList ,//新闻列表,显示负责人
        loading,
        MescrollVue,
    },
    data(){
        return{
            listAllData:null, //页面数据
            newsDataList:[], //新闻列表
            mescroll:null, // mescroll实例对象
            mescrollUp: {
                callback: this.upCallback, // 上拉回调,此处可简写; 相当于 callback: function (page, mescroll) { getListData(page); }
                page: {
                    num: 1, // 当前页码,默认0,回调之前会加1,即callback(page)会从1开始
                    size: 10 // 每页数据的数量
                },
                htmlNodata: '<p class="upwarp-nodata">-- 到底啦 --</p>',
                noMoreSize: 5, // 如果列表已无数据,可设置列表的总数量要大于等于5条才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
                toTop: {
                    src: require('../../assets/mescroll/mescroll-totop.png') // 回到顶部按钮的图片路径,支持网络图
                },
                auto:false,
                lazyLoad: {
                    use: false // 是否开启懒加载,默认false
                }
            },
        }
    },
    created() {
      this.getNewsList()
    },
    methods:{
		getNewsList(){
			this.$http.get(this.dataLink)
            .then(resp=>{
                if(resp.data.status=='ok'){
                  this.listAllData = resp.data;
                  if (resp.data.content) {
                    this.newsDataList= resp.data.content.rs_lists
                  } else {
                    this.newsDataList= resp.data.newslist.rs_lists
                  }
                }
            }); 
        },
        // 上拉加载，下拉刷新
        // mescroll组件初始化的回调,可获取到mescroll对象
        mescrollInit (mescroll) {
            this.mescroll = mescroll
        },
        // 上拉回调 page = {num:1, size:10}; num:当前页 ,默认从1开始; size:每页数据条数,默认10
        upCallback (page, mescroll) {
            var pageNum = page.num; // 页码, 默认从1开始 如何修改从0开始 ?
            this.$http.get(this.dataLink + '&pageid='+pageNum) //调接口
            .then(resp=>{
                if(resp.data.status=='ok'){
                    if (page.num === 1) {
                      this.newsDataList = [];
                    }
                    if(resp.data.content){
                        this.newsDataList=this.newsDataList.concat(resp.data.content.rs_lists);
                    } else {
                        this.newsDataList=this.newsDataList.concat(resp.data.newslist.rs_lists);
                    }
                }else{
                    // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
                    mescroll.endErr()
                }
                this.$nextTick(()=>{
                    if(resp.data.content){
                        mescroll.endSuccess(resp.data.content.rs_lists.length);
                    }else if (resp.data.newslist){
                        mescroll.endSuccess(resp.data.newslist.rs_lists.length);
                    }
                    else{
                        mescroll.endSuccess(0);
                    }
                })
            }).catch(()=>{
                // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
                mescroll.endErr()
            });
        },
        enterDetails(item){
            console.log(item);
        }
    }
}
</script>

<style>
    .indexList{
        width: 100%;
        height: 100%;
        position: relative;
        /* background: red; */
    }
    .indexList .swiper-container {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0px;
        left: 0px;
        /* background: red; */
    }  
    .swiperBox{
        width: 100%;
        padding-bottom: 50%;
        position: relative
    }
    .wenmingshijain{
        width: 100%;
        padding: 0px 12px;
        box-sizing:border-box;
    }
    .wenmingImgBox{
        width: 100%;
        height: auto;
    }
    .wenmingImgBox img{
        width: 100%;
        height: auto;
        margin-top: 10px;
        /* margin: 10px auto; */
    }
    .outLinkerContent{
        width: 100%;
        padding-bottom: 30%;
        position: relative;
        margin-top: 15px;
    }
    .outLinkerContentBox{
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
        align-content: center;
        font-size: 12px;
        text-align: center;
    }
    .outLinkerPer{
        width: 20%;
        height: 50%;
    }
    .outLinkerPerPer {
        width: 100%;
        height: calc(100% - 25px);
    }
    .outLinkerPerPer  img{
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    .outLinkerPerTitle{
        width: 100%;
        line-height: 25px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .indexList .haveContent{
        width: 100%;
        height: 100%;
    }
    .indexList .thumbImg{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .indexList .thumbImg img{
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .indexList .swiper-pagination-bullet{
        width: 20px;
        height: 3px;
        border-radius: 0px;
        background: #ababab;
        opacity: 1;
    }
    .indexList .swiper-pagination-bullet-active{
        background: #fff;
    }
    .indexList .titleBunner{
        position: absolute;
        width: 100%;
        bottom: 30px;
        text-align: center;
        color: #fff;
        font-size: 18px;
        font-weight: 700;
        padding: 0px 10px;
        box-sizing: border-box;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>